<template>
	<div>
		<vs-popup title="Log Listesi" :active.sync="isAktiveLogList">
			<div>
				<h5 class="test-danger">Bilgi</h5>
				<span style="color: dark">
					{{ logOrderNumber }}</span>
			</div>
			<br />

			<vs-table :data="ozellikEslestirmeListesiData" style="min-height: 500px">
				<template slot="thead">
					<vs-th>Kod</vs-th>
					<vs-th>Tarh</vs-th>
					<vs-th>Mesaj</vs-th>
				</template>

				<template slot-scope="{ data }">
					<vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
						<vs-td>
							{{ data[indextr].Code }}
						</vs-td>
						<vs-td>
							{{ data[indextr].Date }}
						</vs-td>
						<vs-td>
							{{ data[indextr].Message }}
						</vs-td>

					</vs-tr>
				</template>
			</vs-table>
		</vs-popup>
	</div>
</template>
<script>
import state from "../../../store/state";
import Store from "../../../store/store";
export default {
	props: ["logOrderNumber", "module"],
	data() {
		return {
			ozellikEslestirmeListesiData: [],
			ozellikEslestirmeListesiData: [],
			isAktiveLogList: false
		}
	},
	methods: {
		getLogList(orderNumb) {
			var vm = this;
			vm.veriler = [];
			const soap = require("soap");
			const url = state.sistemAddress;
			const args = {
				module: vm.module,
				code: orderNumb
			};
			console.log(args)
			soap.createClient(url, function (err, client) {
				client.SystemLogData(args, function (err, result) {
					if (result.SystemLogDataResult == "-1") {
						Store.dispatch("logout");
						//this.$store.dispatch('login', payload)
					}
					vm.veriler = JSON.parse(result.SystemLogDataResult);
					console.log(vm.veriler)
					vm.isAktiveLogList = true;
					vm.ozellikEslestirmeListesiData = vm.veriler
				});
			});
		}
	},

}
</script>